import './i18n/i18n';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


import { createTheme, ThemeProvider } from '@mui/material/styles';
import { ukUA, enUS, plPL } from '@mui/material/locale';

const lng = localStorage.getItem('i18nextLng') || 'en';
const muiLocale = lng.startsWith('pl') ? plPL : lng.startsWith('en') ? enUS :lng.startsWith('uk') ? ukUA: enUS;

const theme = createTheme({}, muiLocale);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <ThemeProvider theme={theme}>
          <App />
      </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
